"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var tslib_1 = require("tslib");
var Table_1 = require("./Table");
Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return Table_1.Table; } });
tslib_1.__exportStar(require("./TableProps"), exports);
// export * from "./Table";
//# sourceMappingURL=index.js.map